module.exports = __webpack_public_path__ + "img/popup_bg.a51585d6.png";